import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

const faqData = [
  {
    question: "Will this actually help me or is it just another AI app?",
    answer:
      "Shattara AI is a personalized AI tutor designed for students, teachers, and learners of all ages. Whether you're struggling with homework, preparing for exams, or exploring new subjects, our intelligent tutoring system adapts to your unique learning style and pace.",
  },
  {
    question: "How fast will I see a difference in my grades?",
    answer:
      "Our AI analyzes your learning patterns, strengths, and areas for improvement in real-time. It adjusts explanations, provides targeted practice problems, and recommends resources based on your progress — ensuring every session is tailored to help you succeed.",
  },
  {
    question: "Can I use this to prepare for tomorrow's exam?",
    answer:
      "Shattara AI supports a wide range of subjects including mathematics, science, languages, history, and more. From elementary concepts to advanced university-level material, our AI tutor is equipped to help you master any topic.",
  },
  {
    question: "My parents are skeptical. What should I tell them?",
    answer:
      "Absolutely. Shattara AI provides step-by-step explanations, guides you through problem-solving processes, and helps you understand concepts rather than just giving answers — empowering you to learn and grow independently.",
  },
  {
    question: "Is this better than hiring a private tutor?",
    answer:
      "Our platform tracks your learning journey with detailed analytics, showing your improvement over time, identifying knowledge gaps, and celebrating milestones. You'll always know where you stand and what to focus on next.",
  },
  {
    question: "Is my data safe? Does Shattara share or sell it?",
    answer:
      "Yes. We use enterprise-grade encryption and follow strict privacy standards to protect your personal information and learning data. Your progress, questions, and academic records are completely secure and confidential.",
  },
  {
    question: "How do I start and how long does setup take?",
    answer:
      "Getting started is easy! Sign up for free — no credit card required. Start learning immediately with our AI tutor, or book a demo to see how personalized AI tutoring can transform your educational journey.",
  },
];

export const FAQ = () => {
  return (
    <section className="py-24 px-5 md:px-12 bg-muted/30">
      <div className="container mx-auto max-w-[90rem]">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-20">
          {/* Left Column - Title and Description */}
          <div className="flex flex-col gap-6">
            <h2 className="text-5xl md:text-6xl font-medium leading-tight tracking-tight text-foreground">
              Got Questions? We've Got You.
            </h2>
            <p className="text-lg md:text-xl text-muted-foreground leading-relaxed">
              Discover how AI-powered personalized tutoring, adaptive learning, and real-time progress tracking are
              transforming the way students learn and achieve their academic goals.
            </p>
          </div>

          {/* Right Column - Accordion */}
          <div className="flex flex-col gap-0">
            <Accordion type="single" collapsible className="w-full">
              {faqData.map((faq, index) => (
                <AccordionItem key={index} value={`item-${index}`} className="border-b border-border">
                  <AccordionTrigger className="text-left py-7 hover:no-underline">
                    <span className="text-[22px] font-semibold uppercase text-primary pr-4">{faq.question}</span>
                  </AccordionTrigger>
                  <AccordionContent className="text-base text-muted-foreground pb-7">{faq.answer}</AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </div>
        </div>
      </div>
    </section>
  );
};
